import { Form, Select, DatePicker, Button } from 'antd';
import React, {useEffect, useState} from 'react';
import { getBrandsAsSelect } from '../../../services/serviceBrand';

const {RangePicker} = DatePicker;

const CustomerOfferFilters = ({updateSignal}) => {
    const {form} = Form.useForm();
    const [brands, setBrands] = useState([]);

    useEffect(() => {
        getBrandsAsSelect()
            .then(({data}) => {
                if(data && data.length) {
                    const structured = data.map(i => ({label: i.label, key:i.key, value:i.key}));
                    setBrands(structured); 
                }
            })
    }, []);
    
    const statusSelects = [
        {label: 'OLUMLU', value: 1, key: 1},
        {label: 'OLUMSUZ', value: 2, key: 2},
        {label: 'BEKLİYOR', value: 0, key: 0}
    ];

    const onFormSubmit = (fields) => updateSignal(fields);

    const selectSearch = (input, option) => {
        return (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
    };

    return(
        <>
            <Form
                form={form}
                layout={'inline'}
                onFinish={onFormSubmit}
                style={{marginBottom: '16px'}}
            >
                <Form.Item name={'bidStatus'}>
                    <Select allowClear options={statusSelects} filterOption={selectSearch} style={{minWidth: '150px'}} placeholder={'Durum'}/>
                </Form.Item>
                <Form.Item name={'brandId'}>
                    <Select allowClear options={brands} filterOption={selectSearch} style={{minWidth: '150px'}} placeholder={'Marka'} showSearch/>
                </Form.Item>
                <Form.Item name={'dateRanges'}>
                    <RangePicker format={'DD/MM/YYYY'} />
                </Form.Item>
                <Form.Item>
                    <Button htmlType='submit' type={'primary'}>Güncelle</Button>
                </Form.Item>
            </Form>
        </>
    )
};

export default CustomerOfferFilters;